import { Box } from '@mui/system'
import {styles} from './styles'
import { Typography } from '@mui/material'
import Link from '@mui/material/Link';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
const UnauthorizedUser = () => {
  return (
    <Box sx={styles.mainContainer} >
      <Typography sx={styles.heading} variant='h1' component={"h2"}>OOPS!</Typography>
      <Typography sx={styles.paraText} component={"p"}>You're not authorized to access this page  </Typography>
      <Link sx={styles.linkContainer} href='/dashboard'>
        <Typography sx={styles.linkText} component={"p"}>Take me back to the Dashboard page</Typography>

        <ExitToAppIcon /> 
      </Link>
    </Box>
  )
}

export default UnauthorizedUser